import React from 'react';
import './style.scss';
import clsx from 'clsx';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../../Shared/components/controls/Button/index.js';

const AppHeaderSubMenu = ({ items, onHover, onBlur }) => {
  const visible = items.length > 0;

  return (
    <div
      className={clsx('app-header-sub-menu', visible && 'app-header-sub-menu-visible')}
      onMouseEnter={visible ? onHover : null}
      onMouseLeave={visible ? onBlur : null}
    >
      {items.map((item, index) => (
        <Column data={item} key={index} />
      ))}
    </div>
  );
};

const Column = ({ data }) => (
  <div className="app-header-sub-menu-column">
    {data.fields.items.map((row, index) => (
      <ColumnCell data={row} key={index} />
    ))}
  </div>
);

const ColumnCell = ({ data }) => {
  const { title, items, link } = data.fields;
  return (
    <div className="ahsmc-section">
      {link?.value?.href ? (
        <Link field={link} className="ahsmc-title-link">
          <div className="ahsmc-title">
            <Text field={title} />
          </div>
        </Link>
      ) : (
        <div className="ahsmc-title">
          <Text field={title} />
        </div>
      )}
      {items?.length > 0 && (
        <ul className="ahsmc-links-list">
          {items.map((item, index) => (
            <ColumnCellElement data={item} key={index} />
          ))}
        </ul>
      )}
    </div>
  );
};

const ColumnCellElement = ({ data }) => {
  if (!data.fields.link?.value?.href) return null;
  const linkStyling = !!data.fields.callToAction?.value;
  const separator = !!data.fields.separator?.value;

  return (
    <li
      className={clsx(
        'ahsmc-link',
        linkStyling && 'ahsmc-link-styled',
        separator && 'ahsmc-link-separator'
      )}
    >
      {linkStyling ? (
        <Button link={data.fields.link} variant="text" color="primary" arrow="right" />
      ) : (
        <Link field={data.fields.link} className="ahsmc-link-link" />
      )}
    </li>
  );
};

export default AppHeaderSubMenu;
